export default function generateMetaTitle (siteOptions, page) {
  // console.log('siteOptions: ', siteOptions)
  // console.log('page: ', page)

  if (siteOptions.og_site_name) {
    let title = {
      pageTitle: siteOptions.og_site_name,
      ogTitle: siteOptions.og_site_name
    }

    // If we have a title object in our page data, use it
    page.title
    ? title = {
      pageTitle: page.title.rendered || page.title,
      ogTitle: page.title.rendered || page.title
    }
    : null

    // Check for page title override
    page.page_title_override
    ? title = {
      pageTitle: page.page_title_override,
      ogTitle: page.page_title_override
    }
    : null

    // Check for SEO title
    if (page.seo_enabled) {
      // console.log('SEO enabled')
      page.seo_title
      ? title = {
        pageTitle: page.seo_title,
        ogTitle: page.seo_title
      }
      : null
    }

    // Check for OG title
    if (page.og_enabled) {
      // console.log('OG enabled')
      page.og_title
      ? title.ogTitle = page.og_title
      : null
    }

    // console.log('title', title)
    return title
  }
}



// WEBPACK FOOTER //
// ./client/common/generateMetaTitle.js